import React from 'react';

import { ScreenLink } from '@gogame/screens';

import {
  financialResultDetailsLink,
  financialResultsLink,
} from 'scenes/FinancialResults/navigation';

const EMPTY_RELATED_ACTION_ID = '-1';

export const FinancialResultsLink = ({
  relatedActionId,
  onClick,
  children,
  ...props
}) => {
  const withoutRelatedId = relatedActionId === EMPTY_RELATED_ACTION_ID;
  return (
    <ScreenLink
      link={
        withoutRelatedId ? financialResultsLink : financialResultDetailsLink
      }
      params={
        withoutRelatedId
          ? {}
          : {
              id: relatedActionId,
              searchQuery: relatedActionId,
            }
      }
      target={'_blank'}
      fast={true}
      onClick={onClick}
      {...props}
    >
      {children}
    </ScreenLink>
  );
};
